const Profile = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <rect
        x="6"
        y="4"
        width="32"
        height="37"
        rx="3"
        stroke="#333333"
        strokeWidth="2.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 14.7571C13 13.7077 13.8507 12.8571 14.9 12.8571H28.9C29.9493 12.8571 30.8 13.7077 30.8 14.7571C30.8 15.8064 29.9493 16.6571 28.9 16.6571H14.9C13.8507 16.6571 13 15.8064 13 14.7571ZM13 21.7571C13 20.7077 13.8507 19.8571 14.9 19.8571H28.9C29.9493 19.8571 30.8 20.7077 30.8 21.7571C30.8 22.8064 29.9493 23.6571 28.9 23.6571H14.9C13.8507 23.6571 13 22.8064 13 21.7571ZM14.9 26.8571C13.8507 26.8571 13 27.7077 13 28.7571C13 29.8064 13.8507 30.6571 14.9 30.6571H22.9C23.9493 30.6571 24.8 29.8064 24.8 28.7571C24.8 27.7077 23.9493 26.8571 22.9 26.8571H14.9Z"
        fill="#FC8037"
      />
    </svg>
  )
}

export default Profile
